import type { InventoryUnit, InventoryUnitContentItem } from '../types/inventory';

// 拼接单条内容物信息："产品名称(编码:客户自定义编码 条码:第一个分拣条码)×数量件"
export const formatContentItem = (item: InventoryUnitContentItem): string => {
  const code = item.product_code || '-';
  const sortingCode = (item.sorting_codes && item.sorting_codes.length > 0) ? item.sorting_codes[0].code : '-';
  return `${item.product_name}(编码:${code} 条码:${sortingCode})×${item.quantity}件`;
};

// 生成库存单元的展示文本：short用于收起态/列表展示（超过2条内容物时省略），full用于hover提示的完整信息
export const formatInventoryUnitLabel = (unit: InventoryUnit): { short: string; full: string } => {
  const items = unit.content?.items || [];
  if (items.length === 0) {
    return { short: unit.system_barcode, full: unit.system_barcode };
  }
  const full = `${unit.system_barcode} 内容物:${items.map(formatContentItem).join(' ')}`;
  const short = items.length > 2
    ? `${unit.system_barcode} 内容物:${items.slice(0, 2).map(formatContentItem).join(' ')} ...等${items.length}条记录`
    : full;
  return { short, full };
};
